(function () {
    'use strict';

    angular
        .module('app')
        .controller('printerSelection', printerSelection);

    printerSelection.$inject = ['$scope', '$mdDialog', 'loginService', 'printers'];

    function printerSelection(scope, $mdDialog, loginService, printers) {
        /* jshint validthis:true */
        var vm = this;
        vm.title = 'Printer';
        scope.printers = printers;
        scope.loginService = loginService;
        scope.selectedPrinter = "";

        activate(scope);

        function activate(scope) {
            console.log("Loaded printers");
            angular.forEach(printers, function(name) {
                if (name.indexOf('(Default)') != "-1") {
                    scope.selectedPrinter = name;
                }
            });
            console.log(scope.printers);
            scope.OK = loginService.resourceStrings["OK"]; // "OK";
            scope.heading = loginService.resourceStrings["PRINTER"]; // "View";
        }

        scope.onDialogOK = function () {
            $mdDialog.hide(scope.selectedPrinter);
        }
        scope.onDialogCancel = function() {
            $mdDialog.hide(false);
        }
    }
})();